import gift from '@referrals/images/svg/gift.svg';
import graduationCap from '@referrals/images/svg/graduation-cap.svg';
import inviteRibbon from '@referrals/images/svg/invite-ribbon.svg';
import arkaDutta from '@referrals/images/svg/arka-dutta.svg';
import rithishReddy from '@referrals/images/svg/rithish-reddy.svg';
import loudspeakerININ from '@referrals/images/svg/loudspeaker-IN-IN.lottie';
import loudspeakerINUS from '@referrals/images/svg/loudspeaker-IN-US.lottie';
import loudspeakerUSUS from '@referrals/images/svg/loudspeaker-US-US.lottie';
import loudspeakerUSIN from '@referrals/images/svg/loudspeaker-US-IN.lottie';
import jbl from '@referrals/images/jbl-go-2.webp';
import appleWatch from '@referrals/images/apple-watch.webp';
import budzPro from '@referrals/images/budz-pro.webp';
import echoDot from '@referrals/images/echo-dot.webp';
import galaxyWatch from '@referrals/images/galaxy watch.webp';
import ipodsPro from '@referrals/images/ipods-pro.webp';
import marshal from '@referrals/images/marshal.webp';
import miPowerBank from '@referrals/images/mi-powerbank.webp';
import nordWatch from '@referrals/images/nord-watch.webp';
import voucher from '@referrals/images/voucher.webp';
import yeti from '@referrals/images/yeti.webp';
import coins from '@referrals/images/scaler-coins.webp';
import rupee from '@referrals/images/rs-coin.webp';
import rewardcoin from '@referrals/images/reward-coin.webp';
import grouprewards from '@referrals/images/grouprewards.webp';
import dollars from '@referrals/images/dollars.webp';
import santhosh from '@referrals/images/santhosh.webp';

export const baseUrl = '/invite-mentors';
export const apiUrl = '/invite-friends';
export const phoneVerificationUrl = '/users/v2/account';
export const isRequestingCallback = 'isRequestingCallback';
export const base = 'https://d2beiqkhq929f0.cloudfront.net/public_assets';

export const perPage = 6;

export const callbackMap = {
  isRequestingCallback: 'callback_requested',
  isRequestingTextOnWhatsapp: 'text_on_whatsapp_requested',
};

export const callbackButtonTextMap = {
  isRequestingCallback: 'Request a callback',
  isRequestingTextOnWhatsapp: 'Request text on whatsapp',
};

export const availabilityTextMap = {
  isRequestingCallback: 'Please verify your number to get a callback.',
  isRequestingTextOnWhatsapp: `
    Please confirm your whatsapp number and availability`,
};

export const behaviouralActivityTextMap = {
  copiedReferralCode: 'invite_friends_referral_coupon_copied',
  copiedReferralLink: 'invite_friends_referral_link_copied',
  doubleClickedOnReferralCode: 'invite_friends_double_clicked_referral_coupon',
  clickedOnReferralPolicy: 'invite_friends_clicked_on_referral_policy',
  clickedOnFaqs: 'invite_friends_clicked_on_faqs',
  clickedShareCodeOnWhatsapp: 'invite_friends_clicked_share_code_on_whatsapp',
  clickedOnRewardsPdf: 'invite_friends_clicked_on_rewards_pdf',
  selectedPreferredProgram: 'user_selected_preferred_program',
};

export const availabilityOptions = [
  'Weekend first half',
  'Weekend second half',
  'Weekday evening',
];

export const availabilitySteps = {
  isRequestingCallback: [
    `Share your availability`,
    `Our team will get in touch with you`,
    `We will guide you through the process`,
  ],
  isRequestingTextOnWhatsapp: [
    `We will reach out to you on Whatsapp`,
    `Confirm a time to speak with you`,
    `We will guide you through the process`,
  ],
};

export const terms = [
  `Cash rewards are credited into your bank account at the end of every 
  month for every referral who has spent more than 1 month with Scaler 
  successfully. eg. if someone joins the program in a given
  month, the reward will be credited to you at the end of next month.`,
  `In case the engagement of yours or the person referred by you is terminated 
  in less than one month from the date of start, for any reason, you will not 
  be eligible for the referral bonus.`,
  `Your cash reward will be subject to tax deduction as per rules of tax 
  authorities at the time of disbursement.`,
  `Scaler reserves the right to decide whether someone you referred is 
  fit for the referral program being offered or not.`,
];

export const banner = {
  title: `Refer a mentor to scaler family`,
  subheading: `Win referral cash bonus on every intake`,
};

export const cashReward = {
  title: `Select your perfect combination of rewards`,
};

export const storeBanner = {
  header: `Get additional 200 Scaler Coins for each eligible referral 
  shared through `,
  linkText: `Visit Store`,
  link: `/academy/store/`,
  headerHyperLinkText: ` referral manager`,
};

export const friendSuccessModalConfig = {
  heading: 'Referee\'s Details have been saved!',
  subheading: `We will contact your friends shortly.`,
  callbackBtnSupportingText: 'Have any doubts? We are here to help you.',
  callbackBtnText: 'Request a Callback',
  statusBtnSupportingText: 'Check the status of your referrals.',
  statusBtnText: 'Check Status',
};

export const referralStepsImages = [
  {
    step: 1,
    icon: inviteRibbon,
  },
  {
    step: 2,
    icon: graduationCap,
  },
  {
    step: 3,
    icon: gift,
  },
];
export const menteeEnrolledStatus = {
  'On Trial Period': 'Your friend is currently on their trial period',
  'Reward To Be Credited':
    'Your friend’s trial period is over, your rewards will be credited soon',
  'Reward Credited':
    'Your reward has been successfully credited to your bank account',
  Ineligible: 'Oops! Your friend seems to have opted for a refund',
  'On Hold':
    'Rewards are currently on hold and will be '
    + 'processed after payment formalities are completed',
};

export const menteeAppliedStatus = {
  Registration: 'Referral applied. Your friend is yet to apply for courses',
  Waitlist: 'Your friend is in conversation with our admissions team',
  'Entrance Test Issued': 'Your friend is attempting the entrance test soon',
  'Entrance Test Cleared': 'Your friend has successfully cleared their test',
  'Entrance Test Failed': `Your friend hasn't cleared their test yet`,
  Enrolled: 'Your friend has successfully enrolled for our course',
  Onboarded: 'Learner has accessed their dashboard',
  Misfit:
    'Oops! It seems your friend doesn’t have the relevant experience currently',
};

export const referImages = {
  'en-IN-IN': {
    header: loudspeakerININ,
  },
  'en-IN-US': {
    header: loudspeakerINUS,
  },
  'en-US-US': {
    header: loudspeakerUSUS,
  },
  'en-US-IN': {
    header: loudspeakerUSIN,
  },
};

export const reviewQnaBannerConst = {
  header: `Track & resolve the questions asked to you by
  the leads through Scaler Alumni Directory `,
  subHeader: `You can see the unanswered and answered list of questions here. `,
  linkText: `Go to dashboard`,
  link: `/review/questions/`,
};

export const MODAL_NAMES = {
  REWARDS_CALC_MODAL: 'rewardsCalcModal',
  FRIEND_SUCCESS_MODAL: 'friendSuccessModal',
  FRIEND_DETAILS_MODAL: 'friendDetailsModal',
  CONSENT_MODAL: 'consentModal',
  CONSENT_SUCCESS_MODAL: 'consentSuccessModal',
  CELEBRATORY_MODAL: 'celebratoryModal',
};

export const PROGRAM_OPTIONS = [
  { key: 'academy', value: 'Scaler Software Development Program' },
  { key: 'dsml', value: 'Scaler Data Science Program' },
  { key: 'not_sure', value: 'I am not sure. Please ask my friend' },
];

export const rewardsImageObj = {
  jbl,
  appleWatch,
  budzPro,
  echoDot,
  galaxyWatch,
  ipodsPro,
  marshal,
  miPowerBank,
  nordWatch,
  voucher,
  yeti,
  coins,
  rupee,
  rewardcoin,
  grouprewards,
  dollars,
};

export const REWARDS_SECTION_SELECTOR = '#rewards-calculator-new-section';
export const REFERRAL_STATS_TABLE_SELECTOR = '.referrals-stats';

export const REFERRAL_STATS_TABS = {
  referred: {
    key: 'referred',
    title: 'Referred',
  },
  applied: {
    key: 'applied',
    title: 'Referrals yet to join',
  },
  enrolled: {
    key: 'enrolled',
    title: 'Enrolled Referrals',
  },
  appliedSst: {
    key: 'appliedSst',
    title: 'Referral Code Applied',
  },
  sstTestStatus: {
    key: 'sstTestStatus',
    title: 'Test Status',
  },
  appliedSsb: {
    key: 'appliedSsb',
    title: 'Referral Code Applied',
  },
};

export const ReferralManagerWhatsappText = (name) => (
  `Hey, ${name}! `
  + `%0aMy friend is eager to join Scaler! Excited to refer them!`
);

const formatNumber = (locale, number) => {
  if ((locale === 'en-US-IN' || locale === 'en-US-US') && number >= 1000000) {
    return `${Math.floor(number / 1000000)}M`;
  }
  if (number >= 100000) {
    return `${Math.floor(number / 100000)}L`;
  }
  if (number >= 1000) {
    return `${Math.floor(number / 1000)}K`;
  }
  return number.toString();
};

export const rewardsAmount = (locale, enrolledCount) => {
  if (locale === 'en-IN-IN' || locale === 'en-IN-US') {
    return {
      cash: `₹${formatNumber(locale, enrolledCount * 10000)}+`,
      goodies: `₹${formatNumber(locale, enrolledCount * 2000)}+`,
    };
  }
  return {
    cash: `$${enrolledCount * 500}+`,
  };
};

export const RCB_SOURCES = {
  POST_REFUND_PERIOD_JOURNEY: 'post_refund_period_journey',
};

export const SST_APPLICANT_TNC = `${base}/assets/000/067/997/original/
Scaler_Referral_Policy_NSET_Test_Takers.pdf?1710339970`;

export const successStoryTestimonials = [
  {
    comment: 'Having a study partner, whether a friend or a '
             + 'colleague, can make the '
             + 'learning experience even more enriching. '
             + 'There\'s a sense of community '
             + 'that pushes you to go the extra mile.',
    name: `Arka Dutta`,
    profilePic: arkaDutta,
    batch: `DSML Aug23`,
  },
  {
    comment: 'By inviting friends and colleagues to '
             + 'upskill with Scaler, I\'m not only '
             + 'helping them stay ahead of the curve but '
             + 'also contributing to the '
             + 'development of a future-ready workforce.',
    name: `Santhosh`,
    profilePic: santhosh,
    batch: `DSML May23`,
  },
  {
    comment: 'As someone who has benefited from '
             + 'Scaler\'s structured curriculum and '
             + 'community, I feel happy to share the gift '
             + 'of upskilling and empower '
             + 'individuals to thrive in today\'s tech landscape.',
    name: `Rithish Reddy`,
    profilePic: rithishReddy,
    batch: `Academy Oct22`,
  },
];

export const successStoryHeading = 'Referral success stories from our learners';
